import React from 'react'
import { Select as AntdSelect } from 'antd'
import Select from '../../atoms/Select'
import * as ST from './styles'

const LanguageSelector = () => {
  const SUPPOER_LOCALES = [
    {
      name: 'English',
      value: 'en',
      icon: 'gb.svg'
    },
    {
      name: 'Русский',
      value: 'ru',
      icon: 'ru.svg'
    },
    {
      name: '简体中文',
      value: 'zh',
      icon: 'cn.svg'
    }
  ]
  const onSelectLocale = e => {
    localStorage.setItem('lang', e)
    window.location.reload()
  }
  const { Option } = AntdSelect
  const currentLocale = localStorage.getItem('lang')
  /* eslint-disable global-require */
  return (
    <Select
      defaultValue={currentLocale}
      style={{ width: 150, margin: 20 }}
      onChange={onSelectLocale}
      getPopupContainer={trigger => trigger.parentNode}
    >
      {SUPPOER_LOCALES.map(locale => (
        <Option
          key={locale.value}
          value={locale.value}
          style={{
            borderBottom: '1px solid #EFEFF4',
            display: `${locale.value === currentLocale ? 'none' : ''}`
          }}
        >
          <ST.StyledLangMenu>
            <div>
              <img
                src={require(`assets/flags/${locale.icon}`)} // eslint-disable-line import/no-dynamic-require
                style={{ width: 30, height: 20 }}
                alt='flag'
              />
            </div>
            <ST.StyledLangText>{locale.name}</ST.StyledLangText>
          </ST.StyledLangMenu>
        </Option>
      ))}
    </Select>
  )
}

export default LanguageSelector
